function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.13 19.86c2.22-1.8 3.55-3.42 3.55-6.3 0-3.36-2.33-5.7-6.26-5.7-4.27 0-7.32 2.5-7.26 8.47H10C9.84 7.88 15.22 2 24.47 2 34.01 2 38 7.27 38 13.18c0 5.21-2.44 7.93-5.82 10.7l-3.16 2.55c-1.55 1.25-2.05 1.74-2.05 3.64v2.44h-6.55v-3.47c0-3.48.78-4.3 3.72-6.74l3-2.44zm.84 17.81v7.6h-8.6v-7.6h8.6z"
})));